<template>
  <!-- 
  1.화면ID    : MSM_SA_001
  2.화면명    : 영업기회 알람 등록
  3.작성자    : 윤태영 차장
    수정자    : 
  4.화면설명  : 영업관리 알람등록 화면이다. (배치화면처리 된다 )
  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
  -->


  <div class="content-wrap">

    <!-- 영업기회ID -->
    <div class="alarm-headline-wrap">
      <div class="alarm-headline">
        <ElLabel name="영업기회ID">
          <template #end="{id}">
            <div class="input-group">
              <ElInput :id="id" ref="salesIdRef" v-model="state.alarmParams.sales_id" readonly/>
              <ElButton type="s-search" @buttonClick="openModal('salesReg')"></ElButton>

            </div>
          </template>

        </ElLabel>
      </div>
    </div>
    <SalesModal ref="salesRegModalRef" @return="(r) => getInfo(r)" />


    <div class="alarm-card mt-3">
      <div class="alarm-card-head">Warranty 알람설정</div>
      <div class="row g-0 alarm-card-body">

        <div class="col-sm-12 col-lg-6 border-end">
          <div class="alarm-card-stitle">되풀이 방법</div>
          <div class="d-flex align-items-stretch" style="height:14rem;">

            <!--되풀이 방법 radio 영역-->
            <div class="alarm-week">
              <div class="form-check py-2" v-for="(item,index) of iterationRadio" :key="index">
                <ElLabel :name="item.cdNm">
                  <template #start="{id}">
                    <ElRadio
                      v-model="state.alarmParams.w_alarm_prd"
                      :id="id"
                      :value="item.cd"
                      @radioChange="iterationChng('w')"
                    />
                  </template>
                </ElLabel>
              </div>
            </div>

            <div v-if="state.alarmParams.w_alarm_prd === 'D'">
              <div class="p-3">
              </div>
            </div>

            <div v-if="state.alarmParams.w_alarm_prd === 'W'">
              <div class="p-3">
                <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                  <ElLabel :name="day.cdNm">
                    <template #start="{id}">
                      <ElCheckbox
                        v-model="state.alarmParams.w_alarm_week"
                        :id="id"
                        :value="day.cd"
                      />
                    </template>
                  </ElLabel>
                </div>
              </div>
            </div>

            <div v-if="state.alarmParams.w_alarm_prd === 'M'">
              <div class="p-3">
                <div class="d-flex align-items-center">매
                  <ElInput 
                  :id="id" 
                  v-model="state.alarmParams.w_alarm_cyc" 
                  classNm="form-control form-control-sm w-25 m-1" 
                  :onlyNumber="true"
                  />
                  주마다 다음 요일에 되풀이
                </div>
                <div>

                  <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                    <ElLabel :name="day.cdNm">
                      <template #start="{id}">
                        <ElCheckbox
                          v-model="state.alarmParams.w_alarm_week"
                          :id="id"
                          :value="day.cd"
                        />
                      </template>
                    </ElLabel>
                  </div>
                  
                </div>
              </div>
            </div>
            <div v-if="state.alarmParams.w_alarm_prd === 'Y'">
              <div class="p-3">
                  <div class="d-flex align-items-center">매
                    <ElInput 
                    :id="id" 
                    v-model="state.alarmParams.w_alarm_cyc" 
                    classNm="form-control form-control-sm w-25 m-1" 
                    :onlyNumber="true"
                    />
                    년마다
                  </div>
                  <div></div>
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.alarmParams.w_alarm_year = r"
                    :select-date="state.alarmParams.w_alarm_year" />
                    <div>
                  <!-- <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                    <ElLabel :name="day.cdNm">
                      <template #start="{id}">
                        <ElCheckbox
                          v-model="state.alarmParams.w_alarm_week"
                          :id="id"
                          :value="day.cd"
                        />
                      </template>
                    </ElLabel>
                  </div> -->
                </div> 
                </div>    
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-lg-6">
          <div class="alarm-card-stitle">되풀이 범위</div>
          <div class="d-flex align-items-stretch" style="height:14rem;">

            <div class="alarm-week">
              <div class="mb-3">
                <ElLabel name="시작">
                  <template #end="{id}">
                    <DatePicker 
                      :id="id"
                      :frmType="'YMD'" 
                      format="yyyy-MM-dd" 
                      @return="r => state.alarmParams.w_start_dt = r"
                      :select-date="state.alarmParams.w_start_dt" 
                    />
                  </template>
                </ElLabel>
              </div>
            </div>

            <div class="p-3">
              <div class="form-check pb-2">
                <ElLabel name="종료 날짜">
                  <template #start="{id}">
                    <ElRadio
                      ref="endDate"
                      v-model="state.alarmParams.w_end_ck"
                      :id="id"
                      value="1"
                      @radioChange="rdoChange('w')"
                    />
                  </template>
                  <template #end="{id}">
                    <DatePicker 
                      :id="id"
                      :frmType="'YMD'" 
                      format="yyyy-MM-dd" 
                      @return="r => state.alarmParams.w_end_dt = r"
                      :select-date="state.alarmParams.w_end_dt" 
                      :disabled="state.alarmParams.w_end_ck !== '1'"
                    />
                  </template>
                </ElLabel>

                
              

              </div>
              <div class="form-check py-2">

                <ElLabel name="다음 되풀이 후 종료됨" classNm="form-check-label">
                  <template #start="{id}">
                    <ElRadio
                      ref="reEnd"
                      v-model="state.alarmParams.w_end_ck"
                      :id="id"
                      value="2"
                      @radioChange="r=>rdoChange('w')"
                    />
                    
                    
                  </template>
                  <template #end>
                    <div class="d-flex">
                      <ElInput 
                        :id="id" 
                        v-model="state.alarmParams.w_end_cnt" 
                        :onlyNumber="true" 
                        classNm="form-control me-1"  
                        @update:modelValue="CheckNumber" 
                        :disabled="state.alarmParams.w_end_ck !== '2'"
                        :maxlength="4"
                      />
                      <span id="" class="form-text">
                        회
                      </span>
                    </div>
                  </template>
                </ElLabel>

                
              </div>
              <div class="form-check py-2">

                <ElLabel name="종료 날짜 지정하지 않음">
                  <template #start="{id}">
                    <ElRadio
                      ref="noReEnd"
                      v-model="state.alarmParams.w_end_ck"
                      :id="id"
                      value="3"
                      @radioChange="r=>rdoChange('w')"
                    />
                  </template>
                </ElLabel>


                <ElInput v-show="false" v-model="state.alarmParams.w_end_ck"/>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="alarm-card-foot">
        <div>
          <div class="form-check form-switch">

            <ElLabel name="Warranty 알람기능 활성화">
              <template #start="{id}">
                <ElCheckbox
                  v-model="state.alarmParams.w_enable_yn"
                  :id="id"
                />
              </template>
            </ElLabel>

            
          </div>
        </div>
      </div>
    </div>

    <div class="alarm-card mt-3">
      <div class="alarm-card-head">지급일 알람설정</div>
      <div class="row g-0 alarm-card-body">

        <div class="col-sm-12 col-lg-6 border-end">
          <div class="alarm-card-stitle">되풀이 방법</div>
          <div class="d-flex align-items-stretch" style="height:14rem;">

            <div class="alarm-week">
              <div class="form-check py-2" v-for="(item,index) of iterationRadio" :key="index">
                <ElLabel :name="item.cdNm">
                  <template #start="{id}">
                    <ElRadio
                      v-model="state.alarmParams.p_alarm_prd"
                      :id="id"
                      :value="item.cd"
                      @radioChange="iterationChng('p')"
                    />
                  </template>
                </ElLabel>
              </div>
            </div>

            <div v-if="state.alarmParams.p_alarm_prd === 'D'">
              <div class="p-3">
              </div>
            </div>

            <div v-if="state.alarmParams.p_alarm_prd === 'W'">
              <div class="p-3">
                <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                  <ElLabel :name="day.cdNm">
                    <template #start="{id}">
                      <ElCheckbox
                        v-model="state.alarmParams.p_alarm_week"
                        :id="id"
                        :value="day.cd"
                      />
                    </template>
                  </ElLabel>
                </div>
              </div>
            </div>

            <div v-if="state.alarmParams.p_alarm_prd === 'M'">
              <div class="p-3">
                <div class="d-flex align-items-center">매
                  <ElInput :id="id" v-model="state.alarmParams.p_alarm_cyc" classNm="form-control form-control-sm w-25 m-1"  @update:modelValue="CheckNumber"/>
                  주마다 다음 요일에 되풀이
                </div>
                <div>

                  <div class="form-check form-check-inline pt-3" v-for="(day,index) of dailyCheck" :key="index">
                    <ElLabel :name="day.cdNm">
                      <template #start="{id}">
                        <ElCheckbox
                          v-model="state.alarmParams.p_alarm_week"
                          :id="id"
                          :value="day.cd"
                        />
                      </template>
                    </ElLabel>
                  </div>

                </div>
              </div>
            </div>
            <div v-if="state.alarmParams.p_alarm_prd === 'Y'">
              <div class="p-3">
                  <div class="d-flex align-items-center">매
                    <ElInput 
                    :id="id" 
                    v-model="state.alarmParams.p_alarm_cyc" 
                    classNm="form-control form-control-sm w-25 m-1" 
                    :onlyNumber="true"
                    />
                    년마다
                  </div>
                  <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.alarmParams.p_alarm_year = r"
                    :select-date="state.alarmParams.p_alarm_year" />
                </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-lg-6">
          <div class="alarm-card-stitle">되풀이 범위</div>
          <div class="d-flex align-items-stretch" style="height:14rem;">

            <div class="alarm-week">
              <div class="mb-3">
                <ElLabel name="시작">
                  <template #end="{id}">
                    <DatePicker 
                      :id="id"
                      :frmType="'YMD'" 
                      format="yyyy-MM-dd" 
                      @return="r => state.alarmParams.p_start_dt = r"
                      :selectDate="state.alarmParams.p_start_dt" 
                    />
                  </template>
                </ElLabel>
                
              </div>
            </div>
            <div class="p-3">
              <div class="form-check pb-2 pe-2">
                <ElLabel name="종료 날짜">
                  <template #start="{id}">
                    <ElRadio
                      ref="endDate"
                      v-model="state.alarmParams.p_end_ck"
                      value="1"
                      @radioChange="r=>rdoChange('p')"
                    />
                  </template>
                  <template #end="{id}">
                    <DatePicker 
                      :id="id"
                      :frmType="'YMD'" 
                      format="yyyy-MM-dd" 
                      @return="r => state.alarmParams.p_end_dt = r"
                      :selectDate="state.alarmParams.p_end_dt"
                      :disabled="state.alarmParams.p_end_ck !== '1'"
                    />
                  </template>
                </ElLabel>
              </div>
              <div class="form-check py-2">

                <ElLabel name="다음 되풀이 후 종료됨">
                  <template #start="{id}">
                    <ElRadio
                      ref="reEnd"
                      v-model="state.alarmParams.p_end_ck"
                      value="2"
                      @radioChange="r=>rdoChange('p')"
                    />
                  </template>
                  <template #end="{id}">
                    <div class="d-flex">
                      <ElInput 
                        :id="id" 
                        v-model="state.alarmParams.p_end_cnt" 
                        :onlyNumber="true" 
                        classNm="form-control me-1"  
                        @update:modelValue="CheckNumber" 
                        :disabled="state.alarmParams.p_end_ck !== '2'"
                        :maxlength="4"
                      />
                      <span class="form-text">
                        회
                      </span>
                    </div>
                  </template>
                </ElLabel>

              </div>
              <div class="form-check py-2">

                <ElLabel name="종료 날짜 지정하지 않음">
                  <template #start="{id}">
                    <ElRadio
                      :id="id"
                      ref="reEnd"
                      v-model="state.alarmParams.p_end_ck"
                      value="3"
                      @radioChange="r=>rdoChange('p')"
                    />
                  </template>
                </ElLabel>


              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="alarm-card-foot">
        <div>
          <div class="form-check form-switch">
            <ElLabel name="지급일 알람설정 활성화">
                <template #start="{id}">
                  <ElCheckbox
                    :id="id"
                    ref="reEnd"
                    v-model="state.alarmParams.p_enable_yn"
                  />
                </template>
              </ElLabel>

          </div>
        </div>
        <div>
          <ElButton type="search" @buttonClick="fnItemValidation()"> 등록완료</ElButton>
          <!-- <ElButton type="search" @buttonClick="$router.push('/sm/MSM_SA_002')"> 이전</ElButton> -->
        </div>
      </div>
    </div>


  </div>

</template>

<script setup>

import { reactive, onMounted, ref} from 'vue';
import { useRouter } from "vue-router";
import common from '@/js/common';
import DatePicker from '@/components/common/DatePicker.vue';
import SalesModal from "@/components/common/modal/SalesModal.vue";
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { alarmEdit, salesCheck } from '@/api/alarm';
import { salesOptyList } from '@/api/sales';

const salesIdRef = ref();
const router = useRouter();
const salesRegModalRef = ref();
// const pageThree = ref();

// 기간설정 초기화 중 DatePicker에서 한달 후 값으로 입력받아 넣으니 달을 바꿔도 무조건 
// 그 다음달로 초기화 되어 end_dt에 대해서만 적용해 주기 위해 아래 값으로 대체함.
var dt = new Date()
var dtStr = dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + dt.getDate();

onMounted(() => {
  // state.alarmParams.w_end_dt = dtStr;
  // state.alarmParams.p_end_dt = dtStr;
})


const iterationRadio = ref([
  {cd : 'D', cdNm : '매일'},
  {cd : 'W', cdNm : '매주'},
  {cd : 'M', cdNm : '매월'},
  {cd : 'Y', cdNm : '매년'},
])

const dailyCheck = ref([
  {cd : 'A', cdNm : '월요일'},
  {cd : 'B', cdNm : '화요일'},
  {cd : 'C', cdNm : '수요일'},
  {cd : 'D', cdNm : '목요일'},
  {cd : 'E', cdNm : '금요일'},
])

const state = reactive({
  AAA : 'AW',
  BBB : 'AP',
  alarmParams: {
    alarm_seq: '',
    sales_id: '',
    w_alarm_cyc: '',
    w_alarm_prd: 'D',
    w_alarm_week: [],
    w_alarm_year: '',
    w_enable_yn: false,
    w_start_dt: '',
    w_end_dt: '',
    w_end_cnt: 0,
    w_snd_dt: null,
    w_end_ck: '1',
    p_alarm_cyc: 0,
    p_alarm_prd: 'D',
    p_alarm_week: [],
    p_alarm_year: '',
    p_enable_yn: false,
    p_start_dt: '',
    p_end_dt: '',
    p_end_cnt: 0,
    p_snd_dt: null,
    p_end_ck: '1',
    upd_id: ''
  },
  pageType: 'insert'

});

const CheckNumber = (data) => {
  if (data) {
    data = common.checkOnlyNumber(data);
  }
}

//모달open 함수
const openModal = async (modal) => {
  if (modal == "upload") {
    try {
      let params = {
        page_count: 1,
        unit_count: 100000,
      };
      const res = await salesOptyList(params)
      state.excelModalData = res.rtn;
    } catch (err) {
      console.log("api error", err);
      alert("영업ID 조회 실패");
    }
  } else if ((modal = "salesReg")) {
    salesRegModalRef.value.openModal();
  }
};

//모달에서 값 받아오기
const getInfo = (r) => {
  state.alarmParams.sales_id = r.sales_id;
};

const fnItemValidation = async() => {
  let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.

  if (!state.alarmParams.sales_id) {  // to executes a event not null condition
    alert(msg)
    salesIdRef.value.input.focus()
    return false;
  }
  try{
    setIsLoading(true)
    const res = await salesCheck({sales_id : state.alarmParams.sales_id})
    if(res.rtn.code_id === '00002'){
      alert('중복된 영업기회ID 입니다.다른 영업기회ID를 선택해주세요')
      return

    }
  }catch(e){
    console.log(e)
    alert('영업기회 중복검사에 실패했습니다.다시 시도해주세요.')
  }finally{
    setIsLoading(false)
  }

  
  //warranty 알림 활성화 일때 필수값 체크
  if(state.alarmParams.w_enable_yn){

    if(state.alarmParams.w_alarm_prd === 'M'){
      let wAlarmCyc = Number(state.alarmParams.w_alarm_cyc)
      if(wAlarmCyc < 1 || wAlarmCyc > 6){
        alert('주 단위 알람 주기는 1~6이내에 입력해주세요.')
        return
      }
    }

    if(state.alarmParams.w_alarm_prd === 'M' || state.alarmParams.w_alarm_prd === 'W'){
      if(state.alarmParams.w_alarm_week.length <= 0){
        alert('Warranty 알람의 반복요일을 선택해주세요.')
        return
      }
    }

    if(state.alarmParams.w_alarm_prd === 'Y'){
      if(!state.alarmParams.w_alarm_year){
        alert('Warranty 알람의 되풀이 일자를 선택해주세요.')
        return
      }
    }

    
    if(!state.alarmParams.w_start_dt){
      alert('Warranty 알람설정의 시작 날짜를 입력해주세요')
      return
    }
    
    if(state.alarmParams.w_end_ck === '1' && !state.alarmParams.w_end_dt){
      alert('Warranty 알람설정의 종료 날짜를 입력해주세요')
      return
    }

    if(state.alarmParams.w_end_ck === '1' && (state.alarmParams.w_end_dt < state.alarmParams.w_start_dt)){
      alert('Warranty 알람설정의 종료 날짜가 시작날짜보다 빠를 수 없습니다.')
      return
    }
    if(state.alarmParams.w_end_ck === '2' && !state.alarmParams.w_end_cnt){
      alert('Warranty 알람설정의 되풀이 횟수를 입력해주세요')
      return
    }
  }

  //지급일 알림 활성화 일때 필수값 체크
  if(state.alarmParams.p_enable_yn){

    if(state.alarmParams.p_alarm_prd === 'M'){
      let pAlarmCyc = Number(state.alarmParams.p_alarm_cyc)
      if(pAlarmCyc < 1 || pAlarmCyc > 10){
        alert('주 단위 알람 주기는 1~6이내에 입력해주세요.')
        return
      }
    }

    if(state.alarmParams.p_alarm_prd === 'M' || state.alarmParams.p_alarm_prd === 'W'){
      if(state.alarmParams.p_alarm_week.length <= 0){
        alert('지급일 알람의 반복요일을 선택해주세요.')
        return
      }
    }

    if(state.alarmParams.p_alarm_prd === 'Y'){
      if(!state.alarmParams.p_alarm_year){
        alert('지급일의 알람 되풀이 일자를 선택해주세요.')
        return
      }
    }


    if(!state.alarmParams.p_start_dt){
      alert('지급일 알람설정의 시작 날짜를 입력해주세요')
      return
    }
    if(state.alarmParams.p_end_ck === '1' && !state.alarmParams.p_end_dt){
      alert('지급일 알람설정의 종료 날짜를 입력해주세요')
      return
    }

    if(state.alarmParams.p_end_ck === '1' && (state.alarmParams.p_end_dt < state.alarmParams.p_start_dt)){
      alert('지급일 알람설정의 종료 날짜가 시작날짜보다 빠를 수 없습니다.')
      return
    }


    if(state.alarmParams.p_end_ck === '2' && !state.alarmParams.p_end_cnt){
      alert('지급일 알람설정의 되풀이 횟수를 입력해주세요')
      return
    }
  }
  

  RegClick();

}

// const disableEndData = () => {

//   //return true; 
//   return false;  // active condition.

//  }

const rdoChange = (type) => {
  if(type === 'w'){
    // Warranty 종료날짜 선택
    if (state.alarmParams.w_end_ck === '1') {
      state.alarmParams.w_end_cnt = 0
    }
    // Warranty 다음 되풀이 후 종료됨 선택
    else if (state.alarmParams.w_end_ck === '2') {
      state.alarmParams.w_end_dt = ''
    }
    // Warranty 종료날짜 지정하지 않음 선택
    else if (state.alarmParams.w_end_ck === '3') {
      state.alarmParams.w_end_cnt = 0
      state.alarmParams.w_end_dt = ''
    }
  }else{
    // 지급일 종료날짜 선택 
    if (state.alarmParams.p_end_ck === '1') {
      state.alarmParams.p_end_cnt = 0
    }
    // 지급일 다음 되풀이 후 종료됨 선택
    else if (state.alarmParams.p_end_ck === '2') {
      state.alarmParams.p_end_dt = ''
    }
    // 지급일 종료날짜 지정하지 않음 선택
    else if (state.alarmParams.p_end_ck === '3') {
      state.alarmParams.p_end_dt = ''
      state.alarmParams.p_end_cnt = 0
    }
  }

  


}


const ConvertWeek = (getWeek) => {

  var test = getWeek.replace('[', '').replace(']', '').replaceAll('"', '').replaceAll(',', '');
  var str = '';

  if (state.alarmParams.w_alarm_prd == "W" || state.alarmParams.w_alarm_prd == "M") {
    if (test.indexOf('A') == -1) { str += '0' } else { str += 'A' }
    if (test.indexOf('B') == -1) { str += '0' } else { str += 'B' }
    if (test.indexOf('C') == -1) { str += '0' } else { str += 'C' }
    if (test.indexOf('D') == -1) { str += '0' } else { str += 'D' }
    if (test.indexOf('E') == -1) { str += '0' } else { str += 'E' }
  }

  return str;
}


const RegClick = async () => {
  if (confirm("등록 하시겠습니까?")) {
  // 등록, 수정 처리
  try {
    setIsLoading(true)
    let alarmParams = {...state.alarmParams}
    alarmParams.w_alarm_week = ConvertWeek(JSON.stringify(state.alarmParams.w_alarm_week));
    alarmParams.p_alarm_week = ConvertWeek(JSON.stringify(state.alarmParams.p_alarm_week));


    alarmParams.w_enable_yn = alarmParams.w_enable_yn ? 'Y' : 'N'

    alarmParams.p_enable_yn = alarmParams.p_enable_yn ? 'Y' : 'N'

    
    Object.keys(alarmParams).forEach((key)=>{
      if(key.includes('_dt')){
        alarmParams[key] = alarmParams[key] || null
      }
    })
    
     
    const res = await alarmEdit(alarmParams)
    alert("등록완료");
    router.push({ name: 'MSM_SA_002' })
  } catch (err) {
    alert("전송 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
  } // The end of if statement block


}

//되풀이 방법 변경시 값 초기화
function iterationChng(type){
  state.alarmParams[`${type}_alarm_week`] = []
  state.alarmParams[`${type}_alarm_cyc`] = ''
  state.alarmParams[`${type}_alarm_year`] = null
}
</script>